import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PostSignupLandingComponent } from './post-signup-landing.component';
import { MobileDrawerModule } from '../../global-components/mobile-drawer/mobile-drawer.module';
import { IosInstallDrawerModule } from '../../global-components/ios-install-drawer/ios-install-drawer.module';
import { PipesModule } from 'app/pipe/pipe.module';
import { PostSignupLandingRoutingModule } from './post-signup-landing-routing';
import { WaitLoaderModule } from 'app/global-components/wait-loader/wait-loader.module';

@NgModule({
    declarations: [
        PostSignupLandingComponent,
    ],
    imports: [
        CommonModule,
        MobileDrawerModule,
        IosInstallDrawerModule,
        PipesModule,
        PostSignupLandingRoutingModule,
        WaitLoaderModule
    ],
    exports: [PostSignupLandingComponent]
})
export class PostSignupLandingModule { }